import { FormattedMessage, useIntl } from 'react-intl';
import { Stack, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import Head from 'next/head';

import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useUnderMaintenance } from '@/logic/state';
import ImageBoxFuture from '../shared/image-box-future';

const UnderMaintenanceImg = '/icons/shared/under-maintenance.svg';

const UnderMaintenance: FC = () => {
  const theme = useTheme();
  const intl = useIntl();
  const underMaintenanceMode = useUnderMaintenance(s => s.underMaintenanceMode, shallow);

  const underMaintenanceLocalizedString = intl.formatMessage({ id: 'under_maintenance' });

  const underMaintenanceTitle = underMaintenanceMode?.title ?? (
    <FormattedMessage id='under_maintenance.title' />
  );
  const underMaintenanceDescription = underMaintenanceMode?.message ? (
    underMaintenanceMode?.message?.split('\\n')?.map?.((str, index) => (
      <Typography
        key={index}
        component='span'
        sx={{
          display: 'block',
          fontSize: {
            mobile: '16px',
            tablet: pxToRem(30),
          },
          color: theme.palette.grey[60],
        }}
      >
        {str}
      </Typography>
    ))
  ) : (
    <FormattedMessage id='under_maintenance.description' />
  );
  return (
    <>
      <Head>
        <title>{underMaintenanceLocalizedString}</title>
      </Head>
      <Stack
        sx={{
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          paddingX: {
            mobile: '15px',
            tablet: '22px',
          },
          paddingY: {
            mobile: '20px',
            tablet: pxToRem(50),
          },
          width: '100%',
          height: '100%',
          zIndex: 9999,
          backgroundColor: 'white',
          overflow: 'auto',
        }}
      >
        <ImageBoxFuture
          img='/icons/logos/muvi-logo.svg'
          title={intl.formatMessage({
            id: 'images.title.logo',
          })}
          objectFit='contain'
          sx={{
            width: {
              mobile: '64px',
              tablet: pxToRem(194),
            },
            height: {
              mobile: '40px',
              tablet: pxToRem(118),
            },
            marginBottom: {
              mobile: '40px',
              tablet: pxToRem(95),
            },
          }}
        />
        <Stack
          sx={{
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <ImageBoxFuture
            img={UnderMaintenanceImg}
            title={underMaintenanceLocalizedString}
            objectFit='contain'
            sx={{
              width: {
                mobile: '196px',
                tablet: pxToRem(639),
              },
              height: {
                mobile: '120px',
                tablet: pxToRem(393),
              },
              marginBottom: {
                mobile: '42.3px',
                tablet: pxToRem(72),
              },
            }}
          />
          <Typography
            component='h1'
            sx={{
              fontSize: {
                mobile: '22px',
                tablet: pxToRem(40),
              },
              fontWeight: 700,
              fontFamily: theme.palette.typography.font.bold,
              letterSpacing: {
                mobile: '-0.17px',
                tablet: 'normal',
              },
              lineHeight: {
                tablet: pxToRem(60),
              },
              color: theme.palette.grey[80],
              marginBottom: {
                mobile: '16px',
                tablet: pxToRem(32),
              },
            }}
          >
            {underMaintenanceTitle}
          </Typography>
          <Typography
            component='p'
            sx={{
              fontSize: {
                mobile: '16px',
                tablet: pxToRem(30),
              },
              lineHeight: '24px',
              color: theme.palette.grey[60],
            }}
          >
            {underMaintenanceDescription}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export default UnderMaintenance;
